import { currentLocale } from "../lib/i18n";

/** 日付を「マーチャントが見ているカレンダー」で扱うためのヘルパー。
 *
 * 🔴 **`toISOString().slice(0, 10)` を日付入力に使わない。** あれは UTC の日付を返すので、
 *    JST（UTC+9）の店では 00:00〜09:00 のあいだ **前日** が返る＝レポートの既定期間の
 *    終了日が「昨日」になり、その日の売上が黙って範囲外へ落ちる。
 *    日付ピッカーに入れる値も、ファイル名に焼く日付も、マーチャントのローカル日付が正。
 */

/** Date をローカルタイムの `YYYY-MM-DD` にする（UTC へ倒さない）。 */
export function toLocalIsoDate(value: Date): string {
  const year = value.getFullYear();
  const month = String(value.getMonth() + 1).padStart(2, "0");
  const day = String(value.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

/** 今日のローカル日付（`YYYY-MM-DD`）。 */
export function todayLocalIsoDate(): string {
  return toLocalIsoDate(new Date());
}

/**
 * 履歴表に出す日時を、いま表示している言語の書式で返す。
 *
 * 🔴 `toLocaleString("ja-JP")` を直に書かない。ロケールを固定すると英語UIでも
 *    `2026/7/31 9:10:00` のまま出る（EN スクリーンショットで実際に見つけた）。
 *    en は `YYYY-MM-DD HH:mm` ＝ 月/日どちらが先かで迷わない並びにする。
 */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const value = new Date(iso);
  if (Number.isNaN(value.getTime())) return "—";
  if (currentLocale() === "de") return value.toLocaleString("de-DE");
  if (currentLocale() === "en") {
    const time = `${String(value.getHours()).padStart(2, "0")}:${String(
      value.getMinutes(),
    ).padStart(2, "0")}`;
    return `${toLocalIsoDate(value)} ${time}`;
  }
  return value.toLocaleString(currentLocale() === "ja" ? "ja-JP" : currentLocale());
}
